var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFromTo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9892",
    "data-name": "Group 9892",
    transform: "translate(-6 -6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5992",
    "data-name": "Rectangle 5992",
    width: 36,
    height: 36,
    rx: 12,
    transform: "translate(6 6)",
    fill: "#0078d7",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "arrow_back_black_24dp_1_",
    "data-name": "arrow_back_black_24dp (1)",
    transform: "translate(12 12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4194",
    "data-name": "Path 4194",
    d: "M24,0H0V24H24Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4195",
    "data-name": "Path 4195",
    d: "M5.417,11h11.17l-4.88-4.88a1.008,1.008,0,0,1,0-1.42,1,1,0,0,1,1.41,0l6.59,6.59a1,1,0,0,1,0,1.41l-6.59,6.59a1,1,0,0,1-1.41-1.41L16.587,13H5.417a1,1,0,0,1,0-2Z",
    transform: "translate(-0.418)",
    fill: "#0078d7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFromTo);
export default __webpack_public_path__ + "static/media/from_to.500f83e126e2c953f30169a093339792.svg";
export { ForwardRef as ReactComponent };